export default function messageOnGetRule(status) {
    let message

    switch (status) {
        case 'multiple-enabled-rule':
            message =
                'Ops! Ocorreu um problema. Existem mais de uma regra com o status ENABLED. Este comportamento não deveria acontecer.'
            break
        case 401:
            message =
                'Ops! O seu tempo de acesso expirou, para continuar utilizando o sistema é necessário realizar o login.'
            break
        default:
            message = null
    }
    return message
}
